'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.requires.push('bgf.paginateAnything');

EwSiteApp.controller('TerritorialPlansListCtrl', [
  '$scope', '$sce', '$filter', '$http', '$log', '$window', '$timeout',
  function ($scope, $sce, $filter, $http, $log, $window, $timeout) {

    $scope.dataUrl = transferData.dataUrl;
    $scope.startingPage = 0;
    $scope.reloadPage = false;
    $scope.loading = false;
    $scope.plans = { list: [] };

    $scope.toggleItem = function (itm) {
      itm.active = !itm.active;
    };

    function getDefaultParams() {
      return { title: '' };
    }
    $scope.filter = getDefaultParams();

    $scope.$on('pagination:loadStart', function (event, status, config) {
      $scope.loading = true;
    });

    $scope.$on('pagination:loadPage', function (event, status, config) {
      $scope.loading = false;

      // Scroll to the .protectionzones element after a short delay
      $timeout(function () {
        const targetElement = document.querySelector('.protectionzones');
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);  // Adjust the timeout if needed
    });

    $scope.showClear = function () {
      return !($filter('json')($scope.filter) === $filter('json')(getDefaultParams()));
    };

    $scope.resetFilter = function () {
      $scope.filter = getDefaultParams();
    };

    $scope.explicitlyTrustedHtml = function (text) {
      return $sce.trustAsHtml(text);
    };
  }
]);

EwSiteApp.controller('FindUniquePlotCtrl',['$scope', '$sce', '$filter', '$http', '$log', function($scope, $sce, $filter, $http, $log){
	$scope.data = {};
	$scope.items = [];
	$scope.number = "";
	$scope.findUrl = transferData.findUrl;
	$scope.found = false;
	$scope.searched = false;
	$scope.loading = false;
	$scope.message = "";
	$scope.find = function(){
		if($scope.dataUrl !== '' && $scope.number!=''){
			$scope.searched = true;
			$scope.found = false;
			$scope.loading = true;
			$http({
				method: 'GET',
				url: $scope.findUrl,
				params: {number: $scope.number}
			}).then(function(response){
				if(response.data.success) {
					$scope.data = response.data.data;
					$scope.items = response.data.items;
					if($scope.items.length>0){
						$scope.found = true;
					}
				}
				else {
					$scope.data = {};
					$scope.items = [];
					$scope.message = response.data.message;
				}
				$scope.loading = false;
			}, function(response){
				console.log(['Error', response]);
			});
		}
	};
	
	$scope.clear = function(){
		$scope.number = "";
		$scope.found = false;
		$scope.searched = false;
		$scope.loading = false;
	};
	
	$scope.explicitlyTrustedHtml = function(text) {
               return $sce.trustAsHtml(text);
	};
	
	$scope.openTab = function(tab){
		$scope.clear();
		$(tab).addClass('active');
		$('#find').removeClass('active');
	};
}]);